import { set } from "date-fns";
import React, { FC, useState } from "react";
import { Modal } from "react-bootstrap";
import useAppToast from "src/hooks/useAppToast";
import { MoreFieldMappingItem } from "src/interfaces/Template.interface";
import { addNewAttributeValueAsync } from "src/redux/actions/productActions";
// import { addNewAttributeValueAsync } from "src/redux/actions/productActions";
import { useAppDispatch } from "src/redux/storeHooks";
import { useCustomerAccess } from "src/hooks/useCustomerAccess";
import { shouldShowAction, getActionButtonProps, getFormFieldDisabled } from "src/utils/customerAccessUtils";
interface InsertionPayloadItem {
  input_type: string;
  name: string;
  href: string | null;
  display_name: string;
  is_required: boolean;
}
type AddNewAttributeValueModalPropsType = {
  closeModal: () => void
  categoryAttributes: MoreFieldMappingItem
  isVisible: boolean;
  allowDataInsertion?: boolean;
  insertionPayload?: InsertionPayloadItem[] | [];
  setOpenAddNewAttributeValueModal:React.Dispatch<React.SetStateAction<boolean>>;
};
const AddNewAttributeValueModal: FC<AddNewAttributeValueModalPropsType> = ({
  closeModal,
  categoryAttributes,
  isVisible,
  allowDataInsertion,
  insertionPayload,
  setOpenAddNewAttributeValueModal
}) => {
  const [formData, setFormData] = useState<Record<string, any>>({});
  const {successToast, warningToast, errorToast} = useAppToast()
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    console.log(formData,"da")
  };
  const dispatch = useAppDispatch()
  const customerAccess = useCustomerAccess();
  const handleSave = async () => {
    if (!insertionPayload) {
      console.error("Validation Error: insertionPayload is undefined.");
      return;
    }
    const requiredFields = insertionPayload.filter(field => field.is_required);
    const missingFields = requiredFields.filter(field => !formData[field.name]);
    if (missingFields.length > 0) {
      const missingFieldNames = missingFields.map(field => field.display_name).join(", ");
      warningToast(`The following required fields are missing: ${missingFieldNames}`)
      return;
    }
    const numberFields = insertionPayload.filter(field => field.input_type === "number");
    const invalidNumberFields = numberFields.filter(field => {
      const value = formData[field.name];
      return value !== undefined && isNaN(Number(value));
    });
    if (invalidNumberFields.length > 0) {
      const invalidNumberFieldNames = invalidNumberFields.map(field => field.display_name).join(", ");
      warningToast(`The following fields must contain a valid number: ${invalidNumberFieldNames}`)
      return;
    }
    const requestBody = {
      platform_field_id: categoryAttributes.id,
      payload: formData
    };
    try { const res =  await dispatch(addNewAttributeValueAsync(requestBody))
      if(res.payload?.status_code==200){
      successToast(res.payload?.massage)
      setOpenAddNewAttributeValueModal(false)
      closeModal()
    }else {
      warningToast(res.payload?.data?.massage)
    }
  }
 
    catch (error) {
      console.log(error)
    }
  };
  
 
  return (
    <Modal show={isVisible} centered>
      <Modal.Header closeButton onClick={()=> setOpenAddNewAttributeValueModal(false)}>
        <Modal.Title>Add Attribute Value</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          {insertionPayload?.map((field) => (
            <div key={field.name} className="mb-3">
              <label className="form-label fw-bold">
                {field.display_name}
                {field.is_required && <span className="text-danger">*</span>}
              </label>
              {field.input_type === "TEXT" && (
                <input
                  type="text"
                  name={field.name}
                  className="form-control"
                  required={field.is_required}
                  onChange={handleChange}
                />
              )}
              {field.input_type === "number" && (
                <input
                  type="text"
                  name={field.name}
                  className="form-control"
                  required={field.is_required}
                  onChange={handleChange}
                />
              )}
            </div>
          ))}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-secondary"
          onClick={() => setOpenAddNewAttributeValueModal(false)}
        >
          Close
        </button>
        {shouldShowAction(customerAccess, 'edit') && (
          <button 
            className="btn btn-primary" 
            onClick={handleSave}
            {...getActionButtonProps(customerAccess, 'edit')}
            disabled={getFormFieldDisabled(customerAccess)}
          >
            Save Changes
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
export default AddNewAttributeValueModal;